import React, { useEffect, useState } from 'react'
import { Modal } from 'antd'
import closeIcon from 'assets/Images/close.svg'
import plusBlue from 'assets/Images/plusBlue.svg'
import { creationEventStore } from 'state/event/eventCreationStore'
import EmptyData from 'components/global/EmptyData'
import {
  EventEmailTemplateResp,
  FinalEventEmailTemplatePayload,
} from 'types/event/eventStep5'
import TemplateInfo from './TemplateInfo'
import EmailTemplateModal from 'pages/Events/Views/Common/Modals/EmailTemplateModal'
import { useUpdateEmailTemplateForEvent } from 'api/EmailTemplates/EmailTemplates'

interface AddTemplateToEventProps {
  openModal: boolean
  closeModal: React.Dispatch<React.SetStateAction<boolean>>
}

const AddTemplateToEvent: React.FC<AddTemplateToEventProps> = ({
  openModal,
  closeModal,
}) => {
  const eventData = creationEventStore(store => store.eventData)
  const setEventData = creationEventStore(store => store.setEventData)
  const [openTemplateModal, setOpenTemplateModal] = useState<boolean>(false)
  const [loaderId, setLoaderId] = useState<string | null>(null)
  const [templateData, setTemplateData] = useState<
    EventEmailTemplateResp | undefined
  >()

  const handleCancel = () => {
    closeModal(false)
  }
  const { mutate: updateTemplate } = useUpdateEmailTemplateForEvent()
  const handleEditTemplate = (emailTemplate: EventEmailTemplateResp) => {
    setTemplateData(emailTemplate)
    setOpenTemplateModal(true)
  }

  const handleAddTemplate = () => {
    setTemplateData(null)
    setOpenTemplateModal(true)
  }

  const handleAddToEvent = (
    templateId: string,
    operation: 'add' | 'remove',
  ) => {
    setLoaderId(templateId)
    const payload: FinalEventEmailTemplatePayload = {
      emailTemplate: {
        ...templateData,
        status: operation === 'add' ? 'active' : 'draft',
      },
    }
    updateTemplate(
      {
        payload,
        referenceId: eventData._id,
        templateId: templateId,
        reference: 'organization-events',
      },
      {
        onSuccess: data => {
          setEventData({ ...eventData, ...data })
          setLoaderId(null)
        },
        onError: () => {
          setLoaderId(null)
        },
      },
    )
  }

  return (
    <div>
      <Modal
        open={openModal}
        onCancel={handleCancel}
        className="confirmation-email"
        footer={false}
        width={700}
        centered
      >
        <div className="flex-center pt-20px justify-between ">
          <h2 className="w-600 text-18">Scheduled emails</h2>
          <img
            src={closeIcon}
            alt="close-button"
            onClick={handleCancel}
            className="close button pointer"
          />
        </div>
        <p>Set the email template and the trigger when it should be sent.</p>
        <div className="mt-20px h-25rem overflow-auto-y scroller">
          {eventData?.emailTemplates.length > 0 ? (
            <div>
              {eventData?.emailTemplates.map(template => {
                return (
                  <div key={template._id}>
                    <TemplateInfo
                      template={template}
                      loaderId={loaderId}
                      isEventTemplate
                      handleAddToEvent={handleAddToEvent}
                      handleEditTemplate={handleEditTemplate}
                    />
                  </div>
                )
              })}
            </div>
          ) : (
            <div className="h-full flex align-center justify-center">
              <EmptyData message="No templates available" />
            </div>
          )}
        </div>
        <div className="mt-30px flex gap-20px justify-between align-center">
          <button className=" btn-secondary" onClick={handleCancel}>
            cancel
          </button>
          <button
            className="pointer flex align-center gap-16px simple-btn"
            onClick={handleAddTemplate}
          >
            <img src={plusBlue}></img> <p>Add New template</p>
          </button>
        </div>
      </Modal>

      {openTemplateModal && (
        <EmailTemplateModal
          openModal={openTemplateModal}
          closeModal={setOpenTemplateModal}
          organizationId={eventData.organizationId}
          referenceId={eventData._id}
          reference="event"
          data={templateData}
        />
      )}
    </div>
  )
}

export default AddTemplateToEvent
